import React from 'react'

type Props = {
  uid: string
}

const UidShorthand: React.FunctionComponent<Props> = ({ uid }) => <>{`${uid.substring(0, 6)}...`}</>

export default UidShorthand
